<script>
    import {createEventDispatcher} from "svelte/internal";
    import HotelAutoComplete from "../components/HotelAutoComplete.svelte";

    const dispatch = createEventDispatcher();

    const onHotelSelect = (hotelObject) => {
        dispatch("change", hotelObject);
    };

    const onCantFindHotel = () => {
        dispatch("cant_find_hotel");
    }
</script>


<h2 class="text-center mt-none">Choose your hotel</h2>

<div class="row align-items-center">
    <div class="column col-12">
        <div class="form-group" id="findHotel">
            <HotelAutoComplete onSelectCallback={ onHotelSelect } required/>
            <p class="text-light text-center text-medium">
                Cant find your hotel?
                <a href="#" on:click|preventDefault={ onCantFindHotel }>Click here</a>
            </p>
        </div>
    </div>
</div>
